module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_7016.3a80ed05.png";